import Login from "pages/authentication/Login";
import NewEditScript from "pages/editScript";
import SearchResult from "pages/searchResult";
import VerificationPage from "pages/VerificationPage";
import ComposerPage from "pages/composer";
import PageNotFound from "components/PageNotFound";

import { PUBLIC_PATHS, PROTECTED_PATHS } from "./pagePath";
import { type AppRoute } from "./types";
import { Navigate } from "react-router-dom";
import WithSuspense from "components/WithSuspense";
import { lazy } from "react";
import AdminDashboardLayout from "pages/adminDashboard/adminDashboardLayout";
import EditComposer from "pages/composer/EditComposer";
import RegisteredUsers from "components/DashboardContents/Users/RegisteredUsers";
import AllUsersCategory from "components/DashboardContents/Users/AllUsersCategory";
import VerifiedUsers from "components/DashboardContents/Users/VerifiedUsers";
import ActiveUsers from "components/DashboardContents/Users/ActiveUsers";
import WeeklyDownloads from "components/DashboardContents/MonthlyDownloads";
import Subscribers from "components/DashboardContents/Subscribers";
import Revenue from "components/DashboardContents/Revenue";
import SinglePurchases from "components/DashboardContents/SinglePurchases";
import CategoryCatalogue from "pages/categories";
import LanguageCatalogue from "pages/languages";

const AllComposers = WithSuspense(lazy(async () => await import("pages/composer/AllComposers")));
const DashBoard = WithSuspense(lazy(async () => await import("pages/dashboard")));
const ScriptPage = WithSuspense(lazy(async () => await import("pages/scriptPage")));
const CreateComposer = WithSuspense(
  lazy(async () => await import("pages/composer/CreateComposer")),
);
const PaymentOperations = WithSuspense(lazy(async () => await import("pages/paymentOperations")));
const ProductHealth = WithSuspense(lazy(async () => await import("pages/productHealth")));
const GrowthIntelligence = WithSuspense(lazy(async () => await import("pages/growthIntelligence")));

const { LOGIN, SINGLE_SCRIPT, SEARCH_RESULT } = PUBLIC_PATHS;
/**
 * Our application's public paths are contained here
 * @constant
 */
export const PUBLIC_ROUTES: AppRoute[] = [
  { path: "/", element: <Login /> },
  {
    path: LOGIN,
    element: <Login />,
  },
  ...Object.values(PROTECTED_PATHS).map((route) => {
    return {
      path: route,
      element: <Navigate to="/" />,
    };
  }), // this enables you not to access the Protected routes when not logged in
  { path: "*", element: <PageNotFound /> },
];
const {
  UPLOAD_ADMIN,
  NEW_EDIT_SCRIPT,
  NEW_COMPOSER,
  EDIT_COMPOSER,
  COMPOSER,
  CATEGORIES,
  LANGUAGES,
  ALL_COMPOSER,
  DASHBOARD,
  REGISTERED_USERS,
  SUBSCRIBERS,
  WEEKLY_DOWNLOADS,
  USERS_CATEGORY,
  VERIFIED_USERS,
  ACTIVE_USERS,
  REVENUE,
  SINGLE_PURCHASES,
  PAYMENT_OPERATIONS,
  PRODUCT_HEALTH,
  GROWTH_INTELLIGENCE,
} = PROTECTED_PATHS;

export const PROTECTED_ROUTES: AppRoute[] = [
  { path: "/", element: <DashBoard /> },
  { path: DASHBOARD, element: <AdminDashboardLayout /> },
  { path: NEW_EDIT_SCRIPT, element: <NewEditScript /> },
  { path: UPLOAD_ADMIN, element: <VerificationPage /> },
  ...["/uploads", "/uploads/new-script", "/old-uploads-admin", "/test-uploads-admin"].map(
    (path) => ({
      path,
      element: <Navigate to={UPLOAD_ADMIN} replace />,
    }),
  ),
  { path: SINGLE_SCRIPT, element: <ScriptPage /> },
  { path: SEARCH_RESULT, element: <SearchResult /> },
  { path: NEW_COMPOSER, element: <CreateComposer /> },
  { path: EDIT_COMPOSER, element: <EditComposer /> },
  { path: COMPOSER, element: <ComposerPage /> },
  { path: CATEGORIES, element: <CategoryCatalogue /> },
  { path: LANGUAGES, element: <LanguageCatalogue /> },
  { path: ALL_COMPOSER, element: <AllComposers /> },
  { path: USERS_CATEGORY, element: <AllUsersCategory /> },
  { path: REGISTERED_USERS, element: <RegisteredUsers /> },
  { path: VERIFIED_USERS, element: <VerifiedUsers /> },
  { path: ACTIVE_USERS, element: <ActiveUsers /> },
  { path: WEEKLY_DOWNLOADS, element: <WeeklyDownloads /> },
  { path: SUBSCRIBERS, element: <Subscribers /> },
  { path: REVENUE, element: <Revenue /> },
  { path: SINGLE_PURCHASES, element: <SinglePurchases /> },
  { path: PAYMENT_OPERATIONS, element: <PaymentOperations /> },
  { path: PRODUCT_HEALTH, element: <ProductHealth /> },
  { path: GROWTH_INTELLIGENCE, element: <GrowthIntelligence /> },

  ...Object.values(PUBLIC_PATHS).map((route) => {
    return {
      path: route,
      element: <Navigate to="/dashboard" />,
    };
  }), // this enables you not to access the public routes when logged in
  { path: "*", element: <PageNotFound /> },
];
